import { Component } from '@angular/core';

@Component({
    selector: 'easy-divider',
    template: `<mat-divider></mat-divider>`
})
export class EasyDividerComponent {

}